module.exports = "/_next/static/resources/single-75dc8167704b922d8688c8e9a52f6505.jpg";